import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '@material-ui/core/Dialog'
import CloseIcon from '@material-ui/icons/Close'

import styles from './styles.module.scss'

const isPdfDataUrl = (dataUrl) => {
  return dataUrl.startsWith('data:application/pdf;base64,');
}

const convertPdfBase64ToImage = async (pdfBase64) => {
  const base64Content = String(pdfBase64 || '').replace(/^data:application\/pdf;base64,/, '')
  const binaryString = window.atob(base64Content)
  const len = binaryString.length
  const bytes = new Uint8Array(len)

  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  const pdf = await window.pdfjsLib.getDocument(bytes).promise
  const page = await pdf.getPage(1)
  const viewport = page.getViewport({ scale: 2 })
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  canvas.height = viewport.height
  canvas.width = viewport.width

  await page.render({
    canvasContext: context,
    viewport
  }).promise

  return canvas.toDataURL('image/png')
}

const PreviewPDF = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [previewImage, setPreviewImage] = useState('')

  const close = useCallback(() => {
    setPreviewImage('')
    setLoading(false)
    setOpen(false)
  }, [])

  useImperativeHandle(ref, () => ({
    open: async ({ base64 } = {}) => {
      setOpen(true)
      if (isPdfDataUrl(base64)) {
        convertPdfBase64ToImage(base64).then(imageBase64 => {
          setPreviewImage(imageBase64)
        })
        return
      }
      setPreviewImage(base64)
    },
    close,
  }), [close])

  return (
    <Dialog
      onClose={close}
      open={open}
      maxWidth={false}
      PaperProps={{ style: { maxWidth: 1080, width: '100%' } }}
    >
      <div className={styles.previewDialog}>
        <div className={styles.previewHeader}>
          <div className={styles.previewTitle}>{t('Receipt preview')}</div>
          <div className={styles.previewCloseButton} onClick={close}>
            <CloseIcon />
          </div>
        </div>

        <div className={styles.previewBody}>
          {
            loading
              ? <div className={styles.previewLoading}>{t('Generating preview...')}</div>
              : previewImage
                ? <img src={previewImage} alt={t('Invoice preview')} className={styles.previewImage} />
                : <div className={styles.previewLoading}>{t('Unable to generate preview')}</div>
          }
        </div>
      </div>
    </Dialog>
  )
})

export default PreviewPDF
